// extracted by mini-css-extract-plugin
export default {"open_left_widget":"open-left-widget-button_open_left_widget__bMdm3"};